import { network } from 'services/network';
import { useMutation } from 'react-query';

const mutationFn = (params: QueryParams) => {
    return network.post('api/bo/exportSchedulingResultsAsVersion', params).then((response) => response.data);
};

export const useMutationExportNewVersion = () => {
    return useMutation<unknown, QueryError, QueryParams>({ mutationFn: (params) => mutationFn(params) });
};

interface QueryParams {
    metaDataId: number;
    contractId: number;
    projectId: number;
    versionName: string;
    versionDate: number;
    key: string;
}
